import { environment } from '@environment';

export const userHistoryApi = {
  userhistory: `${environment.api.services}/api/travel-proxy-ms/itinerary/summary-by-application-user-id`,
  userDetailBooking: `${environment.api.services}/api/travel-proxy-ms/itinerary?id={detailId}`,
  userTravelEta: `${environment.api.services}/api/ms/travel-etas/{detailId}`,
  air_policies: `${environment.api.services}/api/travel-proxy-ms/air/booking-policies`,
  air_search_exchange: `${environment.api.services}/api/travel-proxy-ms/air/search/exchange`,
  air_exchange_book: `${environment.api.services}/api/travel-proxy-ms/air/exchange/book`,
  rappi_payment: `${environment.api.services}/api/travel-intermediary-ms/summary-branch?token={TravelItineraryId}`,
  cancellation: `${environment.api.services}/api/travel-cancellations/cancellations`,
  hotel_cancellation: `${environment.api.services}/api/travel-cancellations/cancellations`,
  cancellation_reasons: `${environment.api.services}/api/travel-content-admin-ms/cancellation/reasons/products/{type}`,
  resend_voucher: `${environment.api.netactica}/Itinerary/SendVoucher`,
  rappi_itinerary: {
    by_order_id: `${environment.api.netactica}/RappiItinerary/ByOrderId/{orderId}`
  },
  history_detail: {
    last: `${environment.api.services}/api/travel-proxy-ms/itinerary/last`,
    get_detail_by_validate: `${environment.api.services}/api/travel-proxy-ms/itinerary/validate?id={detailId}`,
    get_detail_by_id: `${environment.api.services}/api/travel-proxy-ms/itinerary/{detailId}`,
    validate_payment_itinerary: `${environment.api.services}/api/travel-orders-ms/orders/validate/itineraries/{detailId}`
  },
};
